import { Login } from "../../Components";

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
